/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

$(document).ready(function(){

  let targets = document.querySelectorAll('[data-custom-reveal]');

  if (!targets.length) return;

  let observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(entry => {
        console.log(entry.intersectionRatio);
        if (entry.intersectionRatio >= 0.5) {
          const target = entry.target;

          // Mark the element as visible
          $(target).attr('data-visible', 'true');
  
          // 🔸 Only animate if this is the benefits section
          if (target.classList.contains('benefits-highlights-section')) {
            animateBenefitsSection(target);
          }
        }
      });
    },
    {
      threshold: 0.5
    }
  );

  targets.forEach(target => observer.observe(target));

  function animateBenefitsSection(section) {
    const items = section.querySelectorAll('.benefits-highlight-li');
  
    // Animate from bottom to top
    const reversedItems = Array.from(items);
  
    reversedItems.forEach((el, index) => {
      setTimeout(() => {
        el.classList.add('revealed');
      }, index * 300); // Stagger effect
    });
  }

  $(".testimonial-secondary-list").slick({
      arrows:false,
      dots: false,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 740,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  $(".featured-product-sec-media-list").slick({
      arrows:true,
      dots: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1
  });

  $(".product-meta-title-icon-slider").slick({
      arrows:false,
      dots: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
  });

  $('body').on('click','.featured-product-sec-atc-button', function(){
    var _this = $(this);
    _this.attr("disabled", "disabled");
    _this.attr("aria-busy", "true");
    var items = [];
    var variantId = _this.data('variant-id'); 
    items.push({
          quantity: 1,
          id: variantId
        });
    var data = {items};
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        async: false,
        data: {items},
        dataType: 'json',
        error: function(jqXHR, textStatus, errorThrown){
          var response = $.parseJSON(jqXHR.responseText);
          //alert(response.description);
        },
        success: function() {
          _this.removeAttr("disabled", "disabled");
          _this.removeAttr("aria-busy", "true");
          document.getElementById('mini-cart').open = true; 
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));
        }
      });
  });

  $('body').on('click','[data-product-add-to-cart-button-custom]', function(e){
    e.preventDefault;
    var _this = $(this);
    var thisform = $(this).closest('.shopify-product-form');
    _this.attr("disabled", "disabled");
    _this.attr("aria-busy", "true");
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        async: false,
        data: thisform.serialize(),
        dataType: 'json',
        error: function(jqXHR, textStatus, errorThrown){
          var response = $.parseJSON(jqXHR.responseText);
          //alert(response.description);
        },
        success: function() {
          _this.removeAttr("disabled", "disabled");
          _this.removeAttr("aria-busy", "true");
          document.getElementById('mini-cart').open = true; 
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));
        }
      });
  });

  const container = document.querySelector('.block-swatch-list-wrap.hasleft .block-swatch-list');
  if(container){
    container.scrollLeft = container.scrollWidth;
  }

  function setCookie(name, value, days) {
      var d = new Date;
      d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
      document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
  }
  //get cookie
  function getCookie(name) {
      var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
      return v ? v[2] : null;
  }
  
  document.addEventListener('cart:updated', function(event) {
    var cart = event.detail.cart; // Get the updated content of the cart
    if($('body').hasClass('template-product')){
      var tags = $('body').attr('data-tags').split(',');
      if(tags.includes('except_offer')){
        const currentPid = $('body').attr('data-pid');
        const matchedItems = cart.items.filter(item => item.product_id == currentPid);
        console.log(matchedItems)
        if(matchedItems.length > 0){
          $('.product .product-form__payment-container #AddToCart,#StickyAddToCart').attr('type','button').attr('disabled','disabled').removeAttr('data-product-add-to-cart-button');
        }else{
          $('.product .product-form__payment-container #AddToCart,#StickyAddToCart').attr('type','submit').removeAttr('disabled').attr('data-product-add-to-cart-button',true);
        }
      }
      
      
      console.log(cart);
    }
  });    

  $("body").on("click", ".product-meta_offers-item_copy-code", function () {
    var copy_text = $(this);
    var text = copy_text.attr("code"); // <- get value from custom "code" attribute

    if (!text) return; // prevent copying empty

    // Use modern clipboard API if available
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(function () {
        copy_text.attr("copied", "copied");
        setTimeout(function () {
          copy_text.removeAttr("copied");
        }, 1000);
      });
    } else {
      // Fallback for older browsers
      var $temp = $("<input>");
      $("body").append($temp);
      $temp.val(text).select();
      document.execCommand("copy");
      $temp.remove();
      copy_text.attr("copied", "copied");
      setTimeout(function () {
        copy_text.removeAttr("copied");
      }, 1000);
    }
  });

  // VIDEOLIST SECONDARY
   $('.multi_video-list').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 4000,
      pauseOnHover: false,   // important for mobile
      pauseOnFocus: false,   // avoid pausing on tap
      responsive: [
        {
          breakpoint: 740,
          settings: {
            slidesToShow: 1,
            dots: false,
            pauseOnHover: false,
            pauseOnFocus: false
          }
        }
      ]
  });
  $('.multi_video-list').on('touchend', function () {
    $(this).slick('slickPlay');
  });

   $('.customer-wall_wrapper').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 4000,
      responsive: [
        {
          breakpoint: 740,
          settings: {
            slidesToShow: 1,
            dots: false
          }
        }
      ]
  });

  $('.condition_apply-button').click(function(){
    $(this).toggleClass('active');
   $(this).closest('.product-our-promise-wrap').find('.condition_apply-content').slideToggle();
  });
  
});
if($('#pudding').length > 0){
  var counted = 0;
  function counter() {
    var oTop = $('#pudding').offset().top - window.innerHeight;
    if (counted == 0 && $(window).scrollTop() > oTop) {
      $('.pudding-section-item-num-count').each(function() {
        var $this = $(this),
          countTo = $this.attr('data-count'),
          hasPercentage = countTo.includes('%'); // Check if % exists
        // console.log('countTo', countTo);
        $({
          countNum: $this.text()
        }).animate({
            countNum: countTo
          },
          {
            duration: 3000,
            easing: 'swing',
            step: function() {
              $this.text(Math.floor(this.countNum) + (hasPercentage ? "%" : ""));
            },
            complete: function() {
              $this.text(this.countNum + (hasPercentage ? "%" : ""));
              //alert('finished');
            }
          });
      });
      counted = 1;
    }
  }
  $(document).ready(counter);
  $(window).on('load', counter);
  $(window).on('scroll', counter);
}

